import { ChangeDetectorRef, Component, ElementRef, HostListener, NgZone, OnInit, QueryList, ViewChild, ViewChildren } from '@angular/core';
import {
  animate,
  state,
  style,
  transition,
  trigger,
} from '@angular/animations';
import { DataService } from '../data.service';
import { urls } from '../urls';
import { throttle } from 'lodash';
import { ActivatedRoute, Router } from '@angular/router';
import { MatExpansionPanel } from '@angular/material/expansion';
import { MatSnackBar } from '@angular/material/snack-bar';
import { MatTooltip } from '@angular/material/tooltip';
import { HttpClient, HttpHeaders } from '@angular/common/http';
@Component({
  selector: 'app-product-varient',
  templateUrl: './product-varient.component.html',
  styleUrls: ['./product-varient.component.scss'],
  animations: [
    trigger('detailExpand', [
      state('collapsed', style({ height: '0px', minHeight: '0' })),
      state('expanded', style({ height: '*' })),
      transition(
        'expanded <=> collapsed',
        animate('225ms cubic-bezier(0.4, 0.0, 0.2, 1)')
      ),
    ]),
  ],
})
export class ProductVarientComponent implements OnInit {
  @ViewChildren('sectionRef') sectionRefs!: QueryList<ElementRef>;
  @ViewChild('scrollContainer') scrollContainer!: ElementRef;
  @ViewChildren('groupSectionRef', { read: ElementRef }) groupSectionRefs!: QueryList<ElementRef>; // Use the new name here
  @ViewChild('copyTooltip') copyTooltip!: MatTooltip;


  viewMore = true; // State to toggle view
  panelOpenState = false;
  dataSource: any;
  staticColumns: string[] = ['MSNItemDescription'];
  dynamicColumnsForSingleGroup: string[] = [];
  dynamicColumnsMapForAllGroups = new Map;
  displayedColumns = [];
  columnsToDisplayMap = new Map;
  expandedElement: any;
  selectedCategoryCode;
  selectedCountryName;
  breadCrumFlag: boolean;
  sortedCategoryHierarchy: any;
  expandedPanels: boolean[];
  expandedPanelIndex: number | null = 0;
  groupListDataByBrandName: any;
  pageNumber: number = 0;
  pageSize = 15;
  expandedGroupIdForViewMore: string | null = null;
  selectedSortingAttribute = "";
  selectedBrand: string;
  expandedSingleGroupData: any = [];
  groupsBasedOnBrandsList: Array<{ key: string; value: any }> = [];
  imgPrefix: string = urls.s3Link;
  singleGroupImageLink: string;
  groupsBasedOnBrands;
  selectedGroupId: string = "";
  sortingOrder = "1";
  loadingSingleGroup = false;
  showAllKeyFeaturesForEachMsn: { [key: string]: boolean } = {};
  selectedBrandName: any;
  isLoading: boolean = false;
  private threshold = 20;
  private throttledScrollHandler: () => void;
  private hasMoreSingleGroupData = true;
  private hasMoreMultipleGroupData = true;
  groupsPageMap = new Map<string, number>();  // Map of groupID to page number
  groupsPositions = new Map<string, number>(); // Map of group ID to its position in the DOM
  maxPageNumber: number;
  singleVariantsData: any;
  singleVariantFlag = false;
  singleVarientColumnsToDisplay = ['Images', 'MSN', 'ItemDescription', 'uom', 'MRP', 'listPrice', 'TPTxn'];
  hasMoreSingleVariantData = true;

  constructor(private http:HttpClient,private dataService: DataService, private router: Router, private cdr: ChangeDetectorRef, private ngZone: NgZone, private paramRoute: ActivatedRoute, private snackBar: MatSnackBar) {

    this.pageNumber = 0;
    this.selectedCountryName = dataService.getSelectedCountryName().toUpperCase();
    // Throttle the scroll handler to fire once every 200ms
    this.throttledScrollHandler = throttle(this.onScrollSingleGroup.bind(this), 500);
    this.throttledScrollHandler = throttle(this.onScroll.bind(this), 500);
    this.throttledScrollHandler = throttle(this.onScrollSingleVariant.bind(this), 500);
    this.selectedBrand = dataService.getSelectedBrandId();
    this.selectedGroupId = dataService.getSelectedGroupId();

  }

  ngOnInit(): void {
    this.sortedCategoryHierarchy = this.breadCrumDataBy()

    let categoryCode = '';
    this.paramRoute.queryParams.subscribe(params => {
      this.selectedCategoryCode = params['category'];
    });

    // const categoryCode = this.dataService.getSelectedCategoryCode()
    let url = urls.search + "cis/group/category/group/details?categoryCode=" + this.selectedCategoryCode;
    this.dataService.callRestful('GET', url, null, null, null, null).subscribe(this.getGroupsForSelectedCategoryCode.bind(this))
  }

  ngAfterViewInit() {
    // Ensure sectionRefs is populated
    console.log('ngAfterView', this.sectionRefs);
    if (this.scrollContainer) {
      const container = this.scrollContainer.nativeElement as HTMLElement;
      // Use the container here
      container.addEventListener('scroll', this.throttledScrollHandler);
    }
    this.updateGroupsPositions(); // Access sectionRefs here

    this.cdr.detectChanges(); // Ensure the view is fully initialized

    // setTimeout(() => {
    //   if (this.expandedPanelIndex !== null) {
    //     this.scrollToPanel(this.expandedPanelIndex);
    //   }
    // }, 0);

  }

  getGroupsForSelectedCategoryCode(data) {

    if (data.status) {
      if (typeof data.data === 'object' && data.data !== null && Object.keys(data.data).length === 0) {
        this.dataService.offSpinner()
        this.router.navigateByUrl('/no-result-found')
      }
      if (data.data) {
        this.groupsBasedOnBrands = data.data;
        this.groupsBasedOnBrandsList = Object.keys(data.data).map(key => ({
          key: key,
          value: data.data[key]
        }));
        console.log(this.groupsBasedOnBrands)

        console.log(this.selectedBrand)
        const keys = Object.keys(this.groupsBasedOnBrands);
        let indexOfSelectedBrand = keys.indexOf(this.selectedBrand);
        this.dataService.offSpinner();
        if (indexOfSelectedBrand > -1) {
          this.groupsBasedOnBrandsList = this.moveToFront(this.groupsBasedOnBrandsList, indexOfSelectedBrand)
        }
        // this.mapGroupIdToPageNoByBrandClick(keys[0]);

        this.expandedPanels = this.groupsBasedOnBrandsList.map(() => false);
        // this.expandedPanels[indexOfSelectedBrand]=true;
        // this.expandedPanels[0] = true;
        // this.expandedPanelIndex = indexOfSelectedBrand;

        this.selectedBrandName = this.groupsBasedOnBrandsList[0].value.brandName;
        this.selectedBrand = this.groupsBasedOnBrandsList[0].key
        this.selectedSortingAttribute = '';
        this.openGroup(this.selectedBrand, this.selectedGroupId, 0)
        this.scrollToListItem(this.selectedGroupId)
        // setTimeout(() => {
        //   if (this.expandedPanelIndex !== null) {
        //     this.scrollToPanel(this.expandedPanelIndex);
        //   }
        // }, 0);
        console.log(this.groupsBasedOnBrandsList)
      }
    } else {
      this.dataService.offSpinner();
      this.dataService.showMessage('error', data.message);
    }

  }

  moveToFront(arr, index) {
    // Check if the index is valid
    if (index < 0 || index >= arr.length) {
      throw new Error('Index out of bounds');
    }

    // Remove the element from the specified index
    const [element] = arr.splice(index, 1);

    // Insert the element at the start of the array
    arr.unshift(element);

    return arr;
  }


  // Call this method to scroll to a specific list item within a group section
  scrollToListItem(groupId: string) {

    console.log('li section refs', this.groupSectionRefs)
    this.ngZone.run(() => {
      setTimeout(() => {
        this.cdr.detectChanges(); // Trigger change detection
        const section = this.groupSectionRefs.find(ref => ref.nativeElement.id === groupId);
        console.log('li with groupId', section)
        if (section) {
          section.nativeElement.scrollIntoView({
            behavior: 'smooth',
            block: 'center',
            inline: 'center',
          });
          setTimeout(() => {
            window.scrollBy(0, -20);
          }, 500);

        } else {
          console.error('Section not found with ID:', groupId);
        }
      }, 0);
    });
  }

  mapGroupIdToPageNoByBrandClick(key) {
    console.log(key)
    let groupDetails = this.groupsBasedOnBrands[key].groupingDetails;
    this.groupsPageMap.clear();

    groupDetails.forEach((item, i) => {
      const groupId = item.idGroup;
      const pageNo = Math.floor(i / 4);

      this.groupsPageMap.set(groupId, pageNo);
    })

    console.log(this.groupsPageMap)
  }

  toggleViewMore(groupId, brandName) {
    this.dynamicColumnsForSingleGroup = this.getDynamicColumnsMapValue(groupId)
    this.selectedBrandName = brandName
    this.expandedGroupIdForViewMore = groupId;
    this.pageNumber = 0;
    let url = urls.search + "cis/group/products?pageNo=" + this.pageNumber + "&pageSize=" + this.pageSize;

    let payload = {
      'cisGroupId': groupId,
      'sortingAttribute': this.selectedSortingAttribute,
      'sortingOrder': this.sortingOrder
    }

    this.dataService.callRestful('POST', url, payload, null, null, null).subscribe(data => {
      // Check if data is an array and has no items
      if (Array.isArray(data.data) && data.data.length === 0) {
        this.hasMoreSingleGroupData = false;  // Stop further API calls
        this.isLoading = false;
        this.dataService.offSpinner()
      }

      if (data.status && data.data) {
        this.expandedSingleGroupData = data.data;
        this.staticColumns = ['MSNItemDescription']
        this.dynamicColumnsForSingleGroup = this.extractAttributeKeys(this.expandedSingleGroupData);
        console.log(this.dynamicColumnsForSingleGroup)
        this.displayedColumns = [...this.staticColumns, ...this.dynamicColumnsForSingleGroup];
        this.staticColumns = ['uom', 'MRP', 'listPrice', 'TPTxn']
        this.displayedColumns.push(...this.staticColumns)
        console.log(this.displayedColumns)

        this.updateSupplierDetailsForSingleGroup();


        console.log(this.expandedSingleGroupData)
        this.isLoading = false;

        this.dataService.offSpinner()
      } else {
        this.isLoading = false;

        this.dataService.offSpinner()
      }
    })
    // this.getDataForSingleGroup(groupId,"1","")

  }

  toggleViewLess(groupId) {
    this.expandedGroupIdForViewMore = null;
    this.hasMoreSingleGroupData = true;

    this.scrollToGroup(groupId);

  }

  // Check if the section is currently expanded
  isExpanded(groupId: string): boolean {
    return this.expandedGroupIdForViewMore === groupId;
  }

  @HostListener('scroll', ['$event'])
  onScrollSingleGroup = throttle(function (event: Event) {
    console.log('hasmoreSingleGroupData', this.hasMoreSingleGroupData)
    console.log('isLoading', this.isLoading)
    console.log('singleVariantFlag', this.singleVariantFlag)
    if (!this.hasMoreSingleGroupData || this.isLoading || this.singleVariantFlag) return;


    const scrollContainer = (event.target as HTMLElement);
    const scrollPosition = scrollContainer.scrollTop + scrollContainer.clientHeight;
    const scrollHeight = scrollContainer.scrollHeight;

    if (scrollHeight - scrollPosition < this.threshold && !this.isLoading) {
      console.log("scrolling down");
      this.getDataForSingleGroup(this.expandedGroupIdForViewMore, this.sortingOrder, this.selectedSortingAttribute);
    }
  }, 300); // Adjust the debouncing delay as needed



  getDataForSingleGroup(groupId: string, sortingOrder: string, sortingAttribute: string) {
    if (this.isLoading || !this.hasMoreSingleGroupData) return; // Prevent further requests

    this.isLoading = true;
    console.log('has more single group data', this.hasMoreSingleGroupData)
    this.selectedSortingAttribute = sortingAttribute;
    let payload = {
      'cisGroupId': groupId,
      'sortingAttribute': sortingAttribute,
      'sortingOrder': sortingOrder
    }
    this.pageNumber++;


    let url = urls.search + "cis/group/products?pageNo=" + this.pageNumber + "&pageSize=" + this.pageSize;

    this.dataService.callRestful('POST', url, payload, null, null, null).subscribe(this.processDataForSingleGroup.bind(this))
  }

  processDataForSingleGroup(data) {

    // Check if data is an array and has no items
    if (Array.isArray(data.data) && data.data.length === 0) {
      this.hasMoreSingleGroupData = false;  // Stop further API calls
      this.isLoading = false;
      this.dataService.offSpinner()
    }

    else if (data.status && data.data) {
      this.expandedSingleGroupData = [...this.expandedSingleGroupData, ...data.data];
      this.staticColumns = ['MSNItemDescription']
      this.dynamicColumnsForSingleGroup = this.extractAttributeKeys(this.expandedSingleGroupData);
      this.displayedColumns = [...this.staticColumns, ...this.dynamicColumnsForSingleGroup];
      this.staticColumns = ['uom', 'MRP', 'listPrice', 'TPTxn']
      this.displayedColumns.push(...this.staticColumns)

      this.updateSupplierDetailsForSingleGroup();

      // console.log(this.expandedSingleGroupData)
      this.isLoading = false;

      this.dataService.offSpinner()
    } else {
      this.isLoading = false;

      this.dataService.offSpinner()
    }
  }

  displaySortedGroupDetails(groupId, sortingAttribute) {
    if (sortingAttribute == this.selectedSortingAttribute && this.sortingOrder == '1') {
      console.log('desc')
      this.sortingOrder = "2";
    }
    else {
      console.log('asc')
      this.sortingOrder = "1";
    }
    this.selectedSortingAttribute = sortingAttribute
    this.selectedGroupId = groupId;
    let pageNo = this.groupsPageMap.get(groupId)

    let body = {
      'brandId': this.selectedBrand,
      'categoryCode': this.selectedCategoryCode,
      'sortingAttribute': this.selectedSortingAttribute,
      'cisGroupId': groupId,
      'sortingOrder': this.sortingOrder
    }

    let url = urls.search + "cis/group/all/products?pageNo=" + pageNo + "&pageSize=4";

    this.dataService.callRestful('POST', url, body, null, null, null).subscribe(response => {
      if (response.status && response.data) {

        this.groupListDataByBrandName[groupId] = response.data[groupId];

        // this.groupListDataByBrandName = response.data;
        this.dataSource = this.groupListDataByBrandName;
        this.dataService.offSpinner()
        console.log('sorting', this.groupListDataByBrandName)
        this.updateSupplierDetailsInDataSource();
        // this.groupsPositions.clear();
        // this.updateGroupsPositions();
        this.isLoading = false;

        Object.entries(this.groupListDataByBrandName).forEach(([key, value]) => {
          // console.log(`Key: ${key}, Value: ${value}`);
          // Call a function with key and value
          this.dynamicColumnsToDisplay(key, value);
        });
      } else {
        this.dataService.offSpinner()
      }
    })
  }

  displaySortedSingleGroupDetails(groupId, sortingAttribute) {
    if (sortingAttribute == this.selectedSortingAttribute && this.sortingOrder == '1') {
      this.sortingOrder = "2";
    }
    else {
      this.sortingOrder = "1";
    }
    this.hasMoreSingleGroupData = true;
    this.selectedSortingAttribute = sortingAttribute
    this.toggleViewMore(groupId, this.selectedBrandName)
    // let payload = {
    //   'cisGroupId':groupId,
    //   'sortingAttribute':sortingAttribute,
    //   'sortingOrder': this.sortingOrder
    // }

    // let url = urls.search + "cis/group/products?pageNo=" + this.pageNumber + "&pageSize=" + this.pageSize;
    // this.selectedSortingAttribute = sortingAttribute
    // this.dataService.callRestful('POST',url,payload,null, null, null).subscribe(this.processDataForSingleGroup.bind(this))
  }

  extractAttributeKeys(data: any[] | null): string[] {
    // Initialize an empty set to store unique column names
    const columns = new Set<string>();

    // Check if data is valid and is an array
    if (Array.isArray(data)) {
      data.forEach(item => {
        // Ensure item is defined and attributeValuesForPart is an object
        if (item && typeof item === 'object' && item.attributeValuesForPart && typeof item.attributeValuesForPart === 'object') {
          Object.keys(item.attributeValuesForPart).forEach(key => {
            if (key) { // Optional: Check if key is non-empty
              columns.add(key);
            }
          });
        }
      });
    }

    // Convert Set to Array and return
    return Array.from(columns);
  }
  breadCrumDataBy(): Promise<any> {
    this.selectedCategoryCode = this.dataService.getSelectedCategoryCode();
    if (this.selectedCategoryCode) {
      return new Promise<any>((resolve, reject) => {
        this.dataService.getBreadCrumData(this.selectedCategoryCode).subscribe(
          (data) => {
            const categoryIdHirarchy = data['categoryHierarchy'];
            this.sortedCategoryHierarchy = Object.keys(categoryIdHirarchy)
              .filter((key) => key.startsWith('category_name_level') && categoryIdHirarchy[key] !== null)
              .sort()
              .map((key) => ({ key: key, value: categoryIdHirarchy[key] }));

            // Get the value of 'category_name' and append it to the sortedCategoryHierarchy array
            const category_name = categoryIdHirarchy['category_name'];
            if (category_name) {
              this.sortedCategoryHierarchy.push({ key: 'category_name', value: category_name });
            }
            if (this.sortedCategoryHierarchy != null) {
              this.breadCrumFlag = true;
            } else {
              this.breadCrumFlag = false;
            }
            resolve(this.sortedCategoryHierarchy);
          },
          (error) => {
            // Handle error if necessary
            console.error(error);
            reject(error);
          }
        );
      });
    }
  }
  openGroup(brandId: string, groupId: string = "", index: number) {
    this.expandedPanelIndex = this.expandedPanelIndex = index;
    console.log('expandedPanelIndex', this.expandedPanelIndex);
    this.sortingOrder = '1';
    this.selectedSortingAttribute = '';
    this.pageNumber = 0;
    this.singleVariantFlag = false;;
    this.singleVariantsData = [];
    this.mapGroupIdToPageNoByBrandClick(this.selectedBrand)
    if (groupId) {
      this.pageNumber = this.groupsPageMap.get(groupId)
    }
    this.openGroupDetails(brandId, groupId)
  }

  openGroupDetails(brandId: string, groupId: string = "") {

    console.log(brandId)
    this.selectedBrand = brandId
    this.mapGroupIdToPageNoByBrandClick(this.selectedBrand)

    const keysIterator = this.groupsPageMap.keys();
    let lastKey;
    for (const key of keysIterator) {
      lastKey = key; // last iteration assigns the last key to lastKey
    }
    // const lastKey = Array.from(this.groupsPageMap.keys()).pop();
    this.maxPageNumber = this.groupsPageMap.get(lastKey);
    console.log('last page number, ', this.maxPageNumber)

    // console.log(this.groupsBasedOnBrands[index].brandName)
    // this.pageNumber = 0;

    let body = {
      'brandId': brandId,
      'categoryCode': this.selectedCategoryCode,
      'sortingAttribute': this.selectedSortingAttribute,
      'cisGroupId': groupId,
      'sortingOrder': this.sortingOrder
    }

    let url = urls.search + "cis/group/all/products?pageNo=" + this.pageNumber + "&pageSize=4";

    // console.log(body)
    this.dataService.callRestful('POST', url, body, null, null, null).subscribe(response => {
      // If response.data is not an array but an object, check if it's empty
      if (typeof response.data === 'object' && response.data !== null && Object.keys(response.data).length === 0) {
        this.hasMoreMultipleGroupData = false; // Stop further API calls if data object is empty
        this.dataService.offSpinner()
        this.isLoading = false
      }

      if (response.status && response.data) {
        this.groupListDataByBrandName = response.data;
        console.log('initital data ', this.groupListDataByBrandName)
        this.dataSource = this.groupListDataByBrandName;
        this.hasMoreMultipleGroupData = true
        this.dataService.offSpinner()
        console.log('sorting', this.groupListDataByBrandName)
        this.isLoading = false;
        this.updateSupplierDetailsInDataSource();

        Object.entries(this.groupListDataByBrandName).forEach(([key, value]) => {
          // console.log(`Key: ${key}, Value: ${value}`);
          // Call a function with key and value
          this.dynamicColumnsToDisplay(key, value);
          this.groupsPositions.clear();
        });
        setTimeout(() => {
          this.updateGroupsPositions();
          this.scrollToGroup(groupId);
        }, 0);
      } else {
        this.dataService.offSpinner()
      }
    })
  }

  loadMoreGroupsData(brandId, pageNumber: number, groupId: string = "", sortingAttribute: string = "", sortingOrder: number = 1) {

    if (this.isLoading || !this.hasMoreMultipleGroupData) return; // Prevent further requests


    this.isLoading = true;

    let body = {
      'brandId': brandId,
      'categoryCode': this.selectedCategoryCode,
      'sortingAttribute': sortingAttribute,
      'cisGroupId': groupId,
      'sortingOrder': sortingOrder
    }
    this.pageNumber++;


    let url = urls.search + "cis/group/all/products?pageNo=" + this.pageNumber + "&pageSize=4";

    // console.log(body)
    this.dataService.callRestful('POST', url, body, null, null, null).subscribe(this.processGroupsDetail.bind(this))
  }

  @HostListener('scroll', ['$event'])
  onScroll = throttle(function (event: Event) {
    console.log('onScroll')
    if (!this.hasMoreMultipleGroupData || this.isLoading || this.expandedGroupIdForViewMore != null || this.singleVariantFlag)
      return;

    const scrollContainer = (event.target as HTMLElement);
    const scrollPosition = scrollContainer.scrollTop;
    const scrollHeight = scrollContainer.scrollHeight;
    const containerHeight = scrollContainer.clientHeight;
    if (scrollHeight - (scrollPosition + containerHeight) < 10) { // Adjust threshold as needed
      if (this.hasMoreMultipleGroupData && !this.isLoading) {
        console.log("scrolling down on scroll ")
        this.loadMoreGroupsData(this.selectedBrand, this.pageNumber);
      }
    }
    // Check if scrolling up
    // if (scrollPosition < 50 && !this.isLoading) { // Adjust threshold as needed
    //   this.loadPreviousData(this.selectedBrand, this.pageNumber);
    // }
  }, 300);

  processGroupsDetail(response) {
    // If response.data is not an array but an object, check if it's empty
    if (typeof response.data === 'object' && response.data !== null && Object.keys(response.data).length === 0) {
      this.hasMoreMultipleGroupData = false; // Stop further API calls if data object is empty
      this.dataService.offSpinner()
      this.isLoading = false
    }

    else if (response.status && response.data) {
      this.groupListDataByBrandName = { ...this.groupListDataByBrandName, ...response.data }
      console.log('appended data ', this.groupListDataByBrandName)

      // this.groupListDataByBrandName = response.data;
      this.dataSource = this.groupListDataByBrandName;
      this.dataService.offSpinner()

      this.updateSupplierDetailsInDataSource();
      this.updateGroupsPositions();
      this.isLoading = false;

      Object.entries(this.groupListDataByBrandName).forEach(([key, value]) => {
        // console.log(`Key: ${key}, Value: ${value}`);
        // Call a function with key and value
        this.dynamicColumnsToDisplay(key, value);
      });
    } else {
      this.isLoading = false;

      this.dataService.offSpinner()
    }
  }

  loadPreviousData(brandId, pageNumber: number, groupId: string = "", sortingAttribute: string = "", sortingOrder: number = 1) {
    if (this.isLoading || this.pageNumber <= 0) return; // Prevent further requests


    this.isLoading = true;

    let body = {
      'brandId': brandId,
      'categoryCode': this.selectedCategoryCode,
      'sortingAttribute': sortingAttribute,
      'cisGroupId': groupId,
      'sortingOrder': sortingOrder
    }
    this.pageNumber--;


    let url = urls.search + "cis/group/all/products?pageNo=" + this.pageNumber + "&pageSize=4";

    // console.log(body)
    this.dataService.callRestful('POST', url, body, null, null, null).subscribe(this.processGroupsDetail.bind(this))
  }

  dynamicColumnsToDisplay(groupId, data) {
    const elasticGroupDetails = data.elasticGroupDetails
    this.staticColumns = ['MSNItemDescription']
    let dynamicColumns = this.extractAttributeKeys(elasticGroupDetails);
    // console.log("dynamic columns - ", dynamicColumns)
    this.dynamicColumnsMapForAllGroups.set(groupId, dynamicColumns);
    // console.log("dynamic columns map - ", this.dynamicColumnsMapForAllGroups)

    this.displayedColumns = [...this.staticColumns, ...dynamicColumns];
    this.staticColumns = ['uom', 'MRP', 'listPrice', 'TPTxn']
    this.displayedColumns.push(...this.staticColumns)
    // console.log(this.displayedColumns)
    this.columnsToDisplayMap.set(groupId, this.displayedColumns)
    // console.log(this.columnsToDisplayMap)
  }

  capitalizeFirstLetterOfEachWord(input: string): string {
    // Split the string into words
    const words = input.split(' ');

    // Capitalize the first letter of each word
    const capitalizedWords = words.map(word =>
      word.charAt(0).toUpperCase() + word.slice(1)
    );

    // Join the capitalized words back into a single string
    return capitalizedWords.join(' ');
  }

  getColumnsToDisplayMapValue(groupId) {
    return this.columnsToDisplayMap.get(groupId);
  }

  getDynamicColumnsMapValue(groupId) {
    return this.dynamicColumnsMapForAllGroups.get(groupId);
  }

  navigateToGroup(groupId) {
    console.log("navigateToGroup ", groupId)
    this.singleVariantFlag = false;
    this.expandedGroupIdForViewMore = null;
    this.selectedGroupId = groupId
    const pageNo = this.groupsPageMap.get(groupId);
    console.log(this.groupsPositions)

    if (pageNo !== undefined && !this.groupsPositions.has(groupId)) {
      this.pageNumber = pageNo;
      this.isLoading = true;
      this.openGroupDetails(this.selectedBrand, groupId)
      console.log(pageNo, 'pagenumber is defined')
    } else {
      // Call scrollToGroup only if data is available
      console.log('scroll to group')
      this.scrollToGroup(groupId);
    }

    // const position = this.groupsPositions.get(groupId);
    // if (position !== undefined) {
    //   const section = this.sectionRefs.find(ref => ref.nativeElement.id === groupId);
    //   console.log('position', section)
    //   if (section) {
    //     section.nativeElement.scrollIntoView({
    //       behavior: 'smooth',
    //       block: 'center',
    //       inline: 'center',
    //     });
    //     setTimeout(() => {
    //       // Adjust the scroll position by 5px
    //       window.scrollBy(0, 10);
    //     }, 500)
    //   }

    // } else {
    //   console.error('Section not found with ID:', groupId);
    // }

  }

  scrollToGroup(groupId: string) {
    // Run inside NgZone to handle async operations and DOM updates
    this.ngZone.run(() => {
      setTimeout(() => {
        this.cdr.detectChanges(); // Trigger change detection
        const section = this.sectionRefs.find(ref => ref.nativeElement.id === groupId);
        if (section) {
          section.nativeElement.scrollIntoView({
            behavior: 'smooth',
            block: 'center',
            inline: 'center',
          });

          console.log('section', section)

          //Optional: Adjust scroll position slightly if needed
          // setTimeout(() => {
          //   window.scrollBy(0, -20);
          // }, 500);
        } else {
          console.error('Section not found with ID:', groupId);
        }
      }, 0);
    });
  }

  toggleKeyFeatures(msn: string): void {
    this.showAllKeyFeaturesForEachMsn[msn] = !this.showAllKeyFeaturesForEachMsn[msn];
  }

  navigateToBrandwiseCategory(brandName) {
    this.dataService.setSelectedBrandId(this.selectedBrand);
    this.dataService.setSelectedBrandName(brandName)
    console.log(brandName)
    window.open('/company-product-group?brand=' + this.selectedBrand + '&brandName=' + brandName)
  }

  openMsnPdpPage(msn) {
    window.open("/product-detail?category=" + this.selectedCategoryCode + "&productId=" + msn);
  }

  productSupplier(id, supplierAvailable: boolean) {

    const queryParams: any = {};

    if (this.selectedCategoryCode) {
      queryParams.category = this.selectedCategoryCode;
    }
    if (this.selectedBrand && this.selectedBrand.length > 0) {
      queryParams.brandIds = this.selectedBrand;
    }

    // if (this.searchOpenString) {
    //   queryParams.searchStr = this.searchOpenString;
    // }
    if (id) {
      queryParams.productId = id;
    }

    queryParams.sor = 'CIS';

    const url = this.router.createUrlTree(['/supplier-discovery'], { queryParams }).toString();
    window.open(url, '_blank');
  }

  updateSupplierDetailsInDataSource() {
    Object.keys(this.groupListDataByBrandName).forEach(groupId => {
      const groupData = this.groupListDataByBrandName[groupId];

      // Get elasticGroupDetails from the group data
      const items = groupData?.elasticGroupDetails;
      // Filter items where supplierAvailable is true
      const itemsToFetch = items.filter(item => item.supplierAvailable);

      // Make API calls for each filtered item
      itemsToFetch.forEach(item => {
        let body = {
          "warehouseIds": []
        }
        let url = urls.supplierDetails + "?productId=" + item.moglixPartNumber + "&pageNo=0&pageSize=1&orderBy=desc";
        this.dataService.callRestful('POST', url, body, null, null, null, false).subscribe(response => {
          // Update the item with the fetched data under the 'TP' field
          item['tp'] = response?.data?.supplierDetails?.[0]?.lastTp;
          item['txn_date'] = response?.data?.supplierDetails?.[0]?.lastTransactionDate;
          // console.log(`Updated item with TP for ${item.moglixPartNumber}:`, item);
        }, error => {
          console.error(`Error fetching details for ${item.moglixPartNumber}:`, error);
        });
      });
    });


  }

  updateSupplierDetailsForSingleGroup() {
    // Iterate through each item in the array
    this.expandedSingleGroupData.forEach(item => {
      // Check if supplierAvailable is true
      if (item.supplierAvailable) {
        // Show the spinner before making API calls
        this.dataService.onSpinner();

        // Prepare the API request
        let body = {
          "warehouseIds": []
        };
        let url = `${urls.supplierDetails}?productId=${item.moglixPartNumber}&pageNo=0&pageSize=1&orderBy=desc`;

        // Make the API call
        this.dataService.callRestful('POST', url, body, null, null, null, false).subscribe(response => {
          // Update the item with the fetched data under the 'TP' field
          if (response?.data?.supplierDetails?.length > 0) {
            item['tp'] = response.data.supplierDetails[0].lastTp;
            item['txn_date'] = response.data.supplierDetails[0].lastTransactionDate;
          }
          // console.log(`Updated item with TP for ${item.moglixPartNumber}:`, item);
        }, error => {
          console.error(`Error fetching details for ${item.moglixPartNumber}:`, error);
        });
      }
    });
  }

  updateGroupsPositions() {
    console.log('Updating group positions...');
    console.log(this.sectionRefs); // Check if all elements are being captured
    this.cdr.detectChanges();
    // Clear previous positions
    this.groupsPositions.clear();

    this.sectionRefs.forEach((ref: ElementRef) => {
      const element = ref.nativeElement;
      const groupId = element.id;

      if (groupId) {
        // Ensure that the element has an ID and capture its position
        const position = element.offsetTop;
        console.log(`Group ID: ${groupId}, Position: ${position}`); // Debugging

        this.groupsPositions.set(groupId, position);
      } else {
        console.warn('Element does not have an ID:', element);
      }
    });

    // Check if all expected positions are stored
    console.log('Group positions:', this.groupsPositions);
  }

  openSingleVariants(brandId, append: boolean = false) {
    console.log('hasMoreSingle', this.hasMoreSingleVariantData)

    this.singleVariantFlag = true;
    if (append) {
      this.pageNumber++;
    }
    else {
      this.pageNumber = 0;
      this.hasMoreSingleVariantData = true;
    }

    if (this.hasMoreSingleVariantData == false || this.isLoading)
      return;
    let url = urls.search + "cis/group/ungrouped/details?categoryCode=" + this.selectedCategoryCode + "&pageNo=" + this.pageNumber + "&pageSize=" + this.pageSize + "&idBrand=" + this.selectedBrand;

    this.isLoading = true;
    this.dataService.callRestful('GET', url, null, null, null, null).subscribe(response => {
      // Check if data is an array and has no items
      if (Array.isArray(response.data) && response.data.length === 0) {
        if (!append) {
          this.dataService.showMessage('error', 'No Data Found')
          this.singleVariantFlag = false;
        }
        else {
          this.hasMoreSingleVariantData = false;  // Stop further API calls
        }
        console.log('hasMoreSingleVariantsData', this.hasMoreSingleVariantData)
        this.dataService.offSpinner()
      }

      if (response.statusCode == 200 && Array.isArray(response.data) && response.data.length > 0) {
        if (append == false) {
          this.singleVariantsData = response.data;
        } else {
          console.log('appending data')
          this.singleVariantsData = [...this.singleVariantsData, ...response.data]
        }
        this.dataService.offSpinner()
        this.hasMoreSingleVariantData = true;
        this.updateSupplierDetailsForSingleVariant()
        this.isLoading = false;
        console.log(this.singleVariantsData)
      } else {
        this.isLoading = false;
        this.dataService.offSpinner()
      }
    })
  }

  @HostListener('scroll', ['$event'])
  onScrollSingleVariant = throttle(function (event: Event) {
    if (!this.hasMoreSingleVariantData || this.isLoading) return;


    const scrollContainer = (event.target as HTMLElement);
    const scrollPosition = scrollContainer.scrollTop + scrollContainer.clientHeight;
    const scrollHeight = scrollContainer.scrollHeight;

    if (scrollHeight - scrollPosition < 50 && !this.isLoading) {
      console.log("scrolling down");
      this.openSingleVariants(this.selectedBrand, true);
    }
  }, 300);

  updateSupplierDetailsForSingleVariant() {
    // Iterate through each item in the array
    this.singleVariantsData.forEach(item => {
      // Check if supplierAvailable is true
      if (item.supplierAvailable) {
        // Show the spinner before making API calls
        this.dataService.onSpinner();

        // Prepare the API request
        let body = {
          "warehouseIds": []
        };
        let url = `${urls.supplierDetails}?productId=${item.moglixPartNumber}&pageNo=0&pageSize=1&orderBy=desc`;

        // Make the API call
        this.dataService.callRestful('POST', url, body, null, null, null, false).subscribe(response => {
          // Update the item with the fetched data under the 'TP' field
          this.dataService.offSpinner()
          if (response?.data?.supplierDetails?.length > 0) {
            item['tp'] = response.data.supplierDetails[0].lastTp;
            item['txn_date'] = response.data.supplierDetails[0].lastTransactionDate;
          }
          // console.log(`Updated item with TP for ${item.moglixPartNumber}:`, item);
        }, error => {
          console.error(`Error fetching details for ${item.moglixPartNumber}:`, error);
        });
      }
    });
  }

  copyToClipboard(text: string, tooltip: MatTooltip, event?: Event): void {
    // Stop event propagation to prevent row expansion
    if (event) {
      event.stopPropagation();
    }

    // Copy to clipboard logic
    navigator.clipboard.writeText(text).then(() => {
      const originalMessage = tooltip.message;
      tooltip.message = 'Copied!';
      tooltip.show();

      setTimeout(() => {
        tooltip.hide();
        tooltip.message = originalMessage;
      }, 500);
    }).catch(err => {
      console.error('Failed to copy: ', err);
    });
  }


  downloadDocument(doc: any) {
    const token = localStorage.getItem('token');

    const url =       urls.platformdatprod+urls.downloadDocument+`?filePath=${encodeURIComponent(doc.path)}&documentName=${encodeURIComponent(doc.name)}`;

    const headers = new HttpHeaders({
        'Authorization': `Bearer ${token}`
    });

    this.http.get(url, {
        headers: headers,
        responseType: 'blob'
    }).subscribe(
        (blob: Blob) => {

            const fileURL = window.URL.createObjectURL(blob);

            const link = document.createElement('a');
            link.href = fileURL;
            link.download = doc.name;
            link.click();

            window.URL.revokeObjectURL(fileURL);
        },
        error => {
            console.error('Document download failed:', error);
        }
    );
}

}
